<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

export default {
  name: 'LogModal',
  props:[
    "list"
  ],
  data() {
    return {
      options: [],
      form: {
        direction: 1
      },
      id:0,
      submitted: false,
      isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'İstek İp',
          field: 'ip',
        },
        {
          label: 'Cihaz',
          field: this.platform,
        },
        {
          label: 'Tarayıcı',
          field: 'browser',
        },
        {
          label: 'Başarılımı',
          field: this.direction,
          html:true,
        },
        {
          label: 'Tarih',
          field: 'created_at',
        }
      ]
    }
  },
  watch:{
    list(){
      this.rows = []
      this.loadItems()
    }
  },
  methods: {
   
    platform(obj){
       if (obj.platform == 'desktop') {
            return "PC";
        } else if (obj.platform == 'phone') {
            return "Telefon";
        } else if (obj.platform == 'tablet') {
            return "Tablet";
        } else {
            return "Diğer";
        }
    },
    direction(rowObj) {
      const direction = rowObj.success;
      if(direction === 1) return `<span class="badge rounded-pill bg-success">Başarılı</span>`

        return `<span class="badge rounded-pill bg-danger">Başarısız Deneme</span>`
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(`users/${this.list.username}/log`, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    close(){
      this.$parent.$bvModal.hide('modal-log')
    }
  },
};
</script>

<template>
  <b-modal id="modal-log" size="lg" :title="`${list.username} Giriş Bilgileri`"  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>